import emailjs from '@emailjs/browser';

// EmailJS設定
const EMAILJS_SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const EMAILJS_TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
const EMAILJS_PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

// EmailJS初期化
if (EMAILJS_PUBLIC_KEY) {
  emailjs.init(EMAILJS_PUBLIC_KEY);
}

// EmailJS configuration check
const isEmailJSConfigured = () => {
  return process.env.REACT_APP_EMAILJS_SERVICE_ID && 
         process.env.REACT_APP_EMAILJS_TEMPLATE_ID && 
         process.env.REACT_APP_EMAILJS_PUBLIC_KEY;
};

// 自動返信メール送信
export const sendAutoReplyEmail = async (formData, formType) => {
  if (!isEmailJSConfigured()) {
    console.log('EmailJS configuration not complete. Skipping auto-reply email.');
    return { success: false, message: 'EmailJS not configured' };
  }

  const getFormTypeName = (type) => {
    switch (type) {
      case 'general': return '一般問い合わせ';
      case 'materials': return '資料請求';
      case 'demo': return 'デモ申し込み';
      default: return 'お問い合わせ';
    }
  };

  const getAutoReplyMessage = (type) => {
    const baseMessage = `
このたびは株式会社DeepTeLLにお問い合わせいただき、誠にありがとうございます。

以下の内容でお問い合わせを承りました。
担当者より2営業日以内にご連絡させていただきますので、しばらくお待ちください。

【お問い合わせ種類】
${getFormTypeName(type)}

【お客様情報】
お名前: ${formData.name}
メールアドレス: ${formData.email}
会社名: ${formData.company || '未入力'}
電話番号: ${formData.phone || '未入力'}`;

    let additionalInfo = '';

    if (type === 'materials' && formData.interest) {
      const interests = {
        'quantum-ai': '量子AIソリューション',
        'finance': '金融業界向けAI',
        'manufacturing': '製造業向けAI',
        'healthcare': 'ヘルスケアAI',
        'predictive': '予知保全システム',
        'platform': 'AIプラットフォーム全般'
      };
      additionalInfo += `\nご関心のあるソリューション: ${interests[formData.interest] || formData.interest}`;
    }

    if (type === 'demo') {
      if (formData.budget) {
        const budgets = {
          'under-1m': '100万円未満',
          '1m-5m': '100万円 - 500万円',
          '5m-10m': '500万円 - 1,000万円',
          'over-10m': '1,000万円以上',
          'undecided': '未定'
        };
        additionalInfo += `\n導入予算: ${budgets[formData.budget] || formData.budget}`;
      }
      if (formData.timeline) {
        const timelines = {
          'immediately': 'すぐに',
          '3months': '3ヶ月以内',
          '6months': '6ヶ月以内',
          '1year': '1年以内',
          'undecided': '未定'
        };
        additionalInfo += `\n導入時期: ${timelines[formData.timeline] || formData.timeline}`;
      }
    }

    if (formData.message) {
      additionalInfo += `\n\n【お問い合わせ内容】\n${formData.message}`;
    }

    const footer = `
${additionalInfo}

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
株式会社DeepTeLL
〒112-0012 東京都台東区蔵前1-3-28
TEL: 070-1734-7502
Email: info@deeptell.co.jp
Website: https://deeptell.co.jp/
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

このメールは自動配信されています。
ご不明な点がございましたら、上記連絡先までお問い合わせください。`;

    return baseMessage + footer;
  };

  // EmailJS用のテンプレートパラメータ
  const templateParams = {
    to_name: formData.name,
    to_email: formData.email,
    subject: `【DeepTeLL】${getFormTypeName(formType)}を承りました`,
    message: getAutoReplyMessage(formType),
    from_name: '株式会社DeepTeLL',
    reply_to: 'info@deeptell.co.jp'
  };

  try {
    const response = await emailjs.send(
      EMAILJS_SERVICE_ID,
      EMAILJS_TEMPLATE_ID,
      templateParams
    );

    if (response.status === 200) {
      console.log('✅ Auto-reply email sent successfully');
      return { success: true, message: 'Auto-reply email sent successfully' };
    } else {
      console.error('❌ Failed to send auto-reply email:', response);
      return { success: false, message: 'Failed to send auto-reply email' };
    }
  } catch (error) {
    console.error('❌ Error sending auto-reply email:', error);
    return { success: false, message: 'Error sending auto-reply email' };
  }
};

// EmailJS設定テスト
export const testEmailJSConnection = async () => {
  if (!EMAILJS_SERVICE_ID || !EMAILJS_TEMPLATE_ID || !EMAILJS_PUBLIC_KEY) {
    console.error('❌ EmailJS configuration incomplete. Please set all required environment variables.');
    return false;
  }

  const testParams = {
    to_name: 'テストユーザー',
    to_email: 'test@example.com',
    subject: '【DeepTeLL】EmailJS接続テスト',
    message: 'EmailJSの設定が正常に動作しています。',
    from_name: '株式会社DeepTeLL',
    reply_to: 'info@deeptell.co.jp'
  };

  try {
    const response = await emailjs.send(
      EMAILJS_SERVICE_ID,
      EMAILJS_TEMPLATE_ID,
      testParams
    );

    if (response.status === 200) {
      console.log('✅ EmailJS test successful');
      return true;
    } else {
      console.error('❌ EmailJS test failed:', response);
      return false;
    }
  } catch (error) {
    console.error('❌ EmailJS test error:', error);
    return false;
  }
}; 